export default __webpack_public_path__ + "static/media/Søknadsskjema.6f8d794e.docx";